import { useQuery } from '@tanstack/react-query';
import { ChatMessageListItem } from 'src/@types/chat';
import { ChatRequests } from 'src/requests/chat';
import { usePinMessage } from '../../ChatConversation/usePinMessage';

export const usePinnedMessages = ({ channelId }: { channelId: string }) => {
  const { pinMessage } = usePinMessage({ channelId });
  const queryKey = ['pinnedMessages', channelId];

  const {
    data: messagesData,
    isFetching,
    refetch,
  } = useQuery({
    enabled: !!channelId,
    queryKey,
    queryFn: () => ChatRequests.getPinnedMessagesByChannelId(channelId),
  });

  const unpinMessage = (message: ChatMessageListItem) => {
    pinMessage(message).then(() => refetch());
  };

  return {
    messagesData,
    isFetching,
    refetch,
    unpinMessage,
  };
};
